"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Header = _interopRequireDefault(require("../../Header/Header"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _Alert = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Alert"));
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _TextLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/TextLink"));
var _InputField = _interopRequireDefault(require("@kiwicom/orbit-components/lib/InputField"));
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const EmailLoginScreen = ({
  email,
  emailSuggestion,
  onEmailCorrection,
  error,
  onContinue,
  onEmailChange,
  onEmailBlur,
  isLoading,
  emailError
}) => {
  const intl = (0, _reactIntl.useIntl)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {
      title: intl.formatMessage({
        id: "account.login_title.continue_to_account"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalSection.default, {
      dataTest: "MagicLogin-Email-Screen",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        onSubmit: onContinue,
        name: "loginIntro",
        children: [error != null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert.default, {
          dataTest: "MagicLogin-ErrorAlert",
          type: "critical",
          icon: true,
          labelClose: intl.formatMessage({
            id: "orbit.button_close"
          }),
          children: error
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
          autoFocus: true,
          inputMode: "email",
          autoComplete: "username",
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.sign_in_hint",
            values: {
              ref: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
                children: text
              })
            }
          }),
          placeholder: intl.formatMessage({
            id: "account.email_placeholder"
          }),
          value: email,
          error: emailError && intl.formatMessage(emailError),
          onChange: onEmailChange,
          onBlur: onEmailBlur,
          name: "email",
          dataTest: "MagicLogin-Email",
          spaceAfter: "small"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          type: "secondary",
          spaceAfter: "small",
          children: emailSuggestion !== "" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "common.did_you_mean",
            values: {
              x: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
                dataTest: "MagicLogin-EmailCorrector",
                onClick: onEmailCorrection,
                children: emailSuggestion
              })
            }
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          fullWidth: true,
          submit: true,
          loading: isLoading,
          dataTest: "MagicLogin-Continue",
          children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.continue"
          }))
        })]
      })
    })]
  });
};
var _default = EmailLoginScreen;
exports.default = _default;